export default "__VITE_ASSET__745f9492__"